export default [
  {
    path: '/bons-retours',
    name: 'bon-retour-list',
    props: true,
    component: () => import('@/views/returnVouchers/Index.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Bons de retour',
      pageDesc: 'Gestion centralisée des bons de retour logistiques. Filtrez, consultez et validez les retours de colis pour une traçabilité optimale.',
      breadcrumb: [
        {
          text: 'Retours',
          to: { name: 'bon-retour-list' },
        },
        {
          text: 'Liste des bons de retour',
          active: true,
        },
      ],
      accessibility: {
        ariaLabel: 'Liste des bons de retour logistiques',
        description: 'Page accessible pour la gestion, la recherche et la validation des bons de retour. Utilisez les filtres et les actions pour chaque bon.',
      },
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'supplier', 'sales'],
    },
  },
  {
    path: '/bons-retours/create',
    name: 'bon-retour-add',
    props: true,
    component: () => import('@/views/returnVouchers/Create.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Créer un bon de retour',
      pageDesc: 'Créez un bon de retour logistique en sélectionnant le fournisseur et les colis concernés. Assurez la traçabilité et la conformité des retours.',
      breadcrumb: [
        {
          text: 'Retours',
          to: { name: 'bon-retour-list' },
        },
        {
          text: 'Créer un bon de retour',
          active: true,
        },
      ],
      accessibility: {
        ariaLabel: 'Formulaire de création de bon de retour logistique',
        description: 'Sélectionnez le fournisseur, saisissez la référence de colis et ajoutez les colis à retourner. Tous les champs sont obligatoires pour garantir la traçabilité.',
      },
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
  {
    path: '/bons-retours/definitive/create',
    name: 'bon-retour-definitive-add',
    props: true,
    component: () => import('@/views/returnVouchers/CreateDefinitive.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Nouveau traitement anomalie',
      breadcrumb: [
        {
          text: 'Traitement anomalie',
          to: { name: 'bon-retour-list' },
        },
        {
          text: 'Nouveau traitement anomalie',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'customer_support'],
    },
  },
  {
    path: '/bons-retours/definitive/manager-scan',
    name: 'bon-retour-definitive-manager-scan',
    props: true,
    component: () => import('@/views/returnVouchers/CreateDefinitiveManagerScan.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Scan traitement anomalie',
      breadcrumb: [
        {
          text: 'Traitement anomalie',
          to: { name: 'bon-retour-list' },
        },
        {
          text: 'Scan traitement anomalie',
          active: true,
        },
      ],
      roles: ['manager'],
    },
  },
  {
    path: '/bons-retours/definitive/list',
    name: 'bon-retour-definitive-list',
    props: true,
    component: () => import('@/views/returnVouchers/DefinitiveList.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Liste traitement anomalie',
      breadcrumb: [
        {
          text: 'Traitement anomalie',
          to: { name: 'bon-retour-list' },
        },
        {
          text: 'Liste traitement anomalie',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'customer_support'],
    },
  },
  {
    path: '/bons-retours/definitive/show/:id',
    name: 'bon-retour-definitive-show',
    props: true,
    component: () => import('@/views/returnVouchers/DefinitiveShow.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Détail du traitement anomalie',
      breadcrumb: [
        {
          text: 'Traitement anomalie',
          to: { name: 'bon-retour-list' },
        },
        {
          text: 'Liste traitement anomalie',
          to: { name: 'bon-retour-definitive-list' },
        },
        {
          text: 'Détail',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'customer_support'],
    },
  },
  {
    path: '/bons-retours/definitive/verify',
    name: 'bon-retour-definitive-verify',
    props: true,
    component: () => import('@/views/returnVouchers/VerifyDefinitive.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Vérification Manager',
      breadcrumb: [
        {
          text: 'Traitement anomalie',
          to: { name: 'bon-retour-list' },
        },
        {
          text: 'Vérification Manager',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager'],
    },
  },
  {
    path: '/bons-retours/show/:id',
    name: 'bon-retour-show',
    props: true,
    component: () => import('@/views/returnVouchers/Show.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Détail du bon de retour',
      pageDesc: 'Consultez le détail, l’historique et le statut du bon de retour logistique sélectionné. Imprimez ou validez le retour selon vos droits.',
      breadcrumb: [
        {
          text: 'Retours',
          to: { name: 'bon-retour-list' },
        },
        {
          text: 'Détail du bon de retour',
          active: true,
        },
      ],
      accessibility: {
        ariaLabel: 'Détail du bon de retour logistique',
        description: 'Page détaillée du bon de retour logistique. Accédez à l’historique, aux colis concernés et aux actions disponibles.',
      },
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'supplier', 'sales'],
    },
  },
  {
    path: '/bons-retours/inter-agence',
    name: 'bon-retour-list-inter-agence',
    props: true,
    component: () => import('@/views/returnVouchers/interAgency/Index.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Retours inter-agence',
      breadcrumb: [
        {
          text: 'Retours',
          to: { name: 'bon-retour-list' },
        },
        {
          text: 'Inter-agence',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
  {
    path: '/bons-retours/inter-agence/show/:id',
    name: 'bon-retour-inter-agence-show',
    props: true,
    component: () => import('@/views/returnVouchers/interAgency/Show.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Suivi retour inter-agence',
      breadcrumb: [
        {
          text: 'Retours',
          to: { name: 'bon-retour-list' },
        },
        {
          text: 'Inter-agence',
          to: { name: 'bon-retour-list-inter-agence' },
        },
        {
          text: 'Détail',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
  {
    path: '/bons-retours/inter-agence/create',
    name: 'bon-retour-inter-agence-add',
    props: true,
    component: () => import('@/views/returnVouchers/interAgency/Create.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Créer retour inter-agence',
      breadcrumb: [
        {
          text: 'Retours',
          to: { name: 'bon-retour-list' },
        },
        {
          text: 'Inter-agence',
          to: { name: 'bon-retour-list-inter-agence' },
        },
        {
          text: 'Créer',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
  {
    path: '/bons-retours/inter-agence/validate/:id',
    name: 'bon-retour-inter-agence-validate',
    props: true,
    component: () => import('@/views/returnVouchers/interAgency/Validate.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Validation du retour',
      breadcrumb: [
        {
          text: 'Retours',
          to: { name: 'bon-retour-list' },
        },
        {
          text: 'Inter-agence',
          to: { name: 'bon-retour-list-inter-agence' },
        },
        {
          text: 'Validation',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
]
